// @core/api/endpoints/document/create_revision.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateRevisionRequest,
  DocumentLifecycleResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Create revision
 * Creates a new draft revision of an approved/published document-aware entity. Increments version number.
 */
export async function CreateRevision(
  target_type: string,
  target_id: string,
  data: CreateRevisionRequest,
  options?: RequestOptions
): Promise<DocumentLifecycleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:target_type/:target_id/revise`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.post<DocumentLifecycleResponse>(requestPath, data, requestOptions);
}
